import React from "react";

const icons = {
  keyboard: <><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M5 9h1m3 0h1m3 0h1m3 0h1M5 12h1m3 0h1m3 0h1m3 0h1M7 16h10" /></>,
  scissors: <><circle cx="6" cy="6" r="3" /><circle cx="6" cy="18" r="3" /><path d="m8 8 13 13M8 16 21 3" /></>,
  arrowLeft: <path d="M20 12H4m6-6-6 6 6 6" />,
  arrowRight: <path d="M4 12h16m-6-6 6 6-6 6" />,
  chevronUp: <path d="m6 15 6-6 6 6" />,
  print: <><path d="M7 8V3h10v5M7 17H3V8h18v9h-4M7 14h10v7H7zM17 11h1" /></>,
  save: <><path d="M4 3h13l3 3v15H4V3ZM8 3v6h8V3M8 21v-8h8v8" /></>,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v6M12 7v.1" /></>,
  camera: <><path d="M3 7h5l2-3h4l2 3h5v14H3V7Z" /><circle cx="12" cy="13" r="4" /></>,
  copy: <><rect x="8" y="8" width="13" height="13" rx="2" /><path d="M16 8V3H3v13h5" /></>,
  close: <path d="m6 6 12 12M18 6 6 18" />,
  refresh: <><path d="M20 7v5h-5M4 17v-5h5" /><path d="M6 7a7 7 0 0 1 12-1l2 3M4 15l2 3a7 7 0 0 0 12-1" /></>,
  play: <path d="m8 4 12 8-12 8V4Z" />,
  menu: <path d="M4 6h16M4 12h16M4 18h16" />,
  logout: <><path d="M10 4H4v16h6M10 12h10M16 8l4 4-4 4" /></>,
  search: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 4 4" /></>,
  chevronDown: <path d="m6 9 6 6 6-6" />,
  filter: <><path d="M4 7h16M4 17h16" /><circle cx="9" cy="7" r="2" fill="currentColor" stroke="none" /><circle cx="15" cy="17" r="2" fill="currentColor" stroke="none" /></>,
  scan: <><path d="M8 3H3v5M16 3h5v5M21 16v5h-5M8 21H3v-5" /><path d="M7 7h3v3H7zM14 7h3v3h-3zM7 14h3v3H7zM14 14h3v3h-3z" /></>,
  orders: <><rect x="5" y="4" width="14" height="17" rx="2" /><path d="M9 3h6v3H9zM9 11h6M9 15h6" /></>,
  inventory: <><path d="m12 3 9 5-9 5-9-5 9-5ZM3 8v9l9 5 9-5V8M12 13v9M7.5 5.5l9 5" /></>,
  maintenance: <path d="M14.5 5.5a5 5 0 0 0-6.1 6.1L3.5 16.5a2.8 2.8 0 0 0 4 4l4.9-4.9a5 5 0 0 0 6.1-6.1l-3 3-4-4 3-3Z" />,
  receiving: <><path d="M12 3v10M8 9l4 4 4-4M4 13v7h16v-7M4 15h4l2 3h4l2-3h4" /></>,
  production: <><path d="M3 21V8h4v6l6-4v4l7-4v11H3ZM5 8V3h2v5M7 18h1M12 18h1M17 18h1" /></>,
  shipping: <><path d="M3 5h11v12H3V5ZM14 10h4l3 4v3h-7M21 14h-7" /><circle cx="6.5" cy="18" r="2.5" /><circle cx="17.5" cy="18" r="2.5" /></>,
  audit: <><rect x="5" y="4" width="14" height="17" rx="2" /><path d="M9 3h6v3H9zM8 12l2 2 5-5M8 17h7" /></>,
  location: <><path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 0 1 14 0Z" /><circle cx="12" cy="10" r="2.5" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  edit: <><path d="m15 4 5 5M4 20l5-1 12-12a2.8 2.8 0 0 0-4-4L5 15l-1 5ZM4 20h16" /></>,
  eye: <><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" /><circle cx="12" cy="12" r="3" /></>,
  dashboard: <><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></>,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M7 3v4M17 3v4M3 11h18M8 15h2M14 15h2" /></>,
  check: <><circle cx="12" cy="12" r="9" /><path d="m8 12 3 3 5-6" /></>,
  warning: <><path d="m12 3 10 18H2L12 3ZM12 9v5M12 17v.1" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  currency: <><path d="M12 2v20M17 6H9a3 3 0 0 0 0 6h6a3 3 0 0 1 0 6H6" /></>,
  document: <><path d="M14 3H5v18h14V8l-5-5ZM14 3v5h5M8 12h8M8 16h6" /></>,
  chart: <><path d="M3 3v18h18M7 16v-4M12 16V7M17 16v-7" /></>,
  link: <><path d="m10 8 3-3a4.2 4.2 0 0 1 6 6l-3 3M14 16l-3 3a4.2 4.2 0 0 1-6-6l3-3M8 16l8-8" /></>,
  building: <><rect x="5" y="3" width="14" height="18" rx="1" /><path d="M9 7h1M14 7h1M9 11h1M14 11h1M10 21v-6h4v6" /></>,
  settings: <><path d="M4 6h16M4 12h16M4 18h16" /><circle cx="8" cy="6" r="2" fill="white" /><circle cx="16" cy="12" r="2" fill="white" /><circle cx="10" cy="18" r="2" fill="white" /></>,
  return: <><path d="M9 6 3 12l6 6M3 12h12a6 6 0 0 0 6-6" /></>,
  layers: <><path d="m12 3 10 5-10 5L2 8l10-5ZM2 12l10 5 10-5M2 16l10 5 10-5" /></>,
  trash: <><path d="M3 6h18M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7M14 10v7" /></>,
  expand: <path d="M8 3H3v5M16 3h5v5M3 16v5h5M21 16v5h-5M3 3l6 6m12-6-6 6M3 21l6-6m12 6-6-6" />,
  collapse: <path d="M3 8h5V3m13 5h-5V3M3 16h5v5m13-5h-5v5M3 3l5 5m13-5-5 5M3 21l5-5m13 5-5-5" />,
  scale: <><path d="M12 3v18M7 21h10M4 7h16M5 7l-3 7h6L5 7ZM19 7l-3 7h6l-3-7Z" /></>,
};

export default function UIIcon({ name, size = 18, className = "", ...props }) {
  const icon = icons[name];
  if (!icon) return null;

  return (
    <svg
      {...props}
      className={`ui-icon${className ? ` ${className}` : ""}`}
      data-ui-icon={name}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {icon}
    </svg>
  );
}
